import { IProductPriceDetail } from '../../interfaces/Product.interfaces';

export const calculateTotalAddPrice = (priceDetail: IProductPriceDetail[]) => {
  let sum = 0;

  priceDetail.forEach((priceInfo) => {
    if (priceInfo.type === 'ADD') {
      sum += priceInfo.amount;
    }
  });

  return sum;
};

export const calculateTotalSubtractPrice = (priceDetail: IProductPriceDetail[]) => {
  let sum = 0;

  priceDetail.forEach((priceInfo) => {
    if (priceInfo.type === 'SUBTRACT') {
      sum += priceInfo.amount;
    }
  });

  return sum;
};

export const calculateAnonymousUserPrice = (priceDetail: IProductPriceDetail[]) => {
  let price = 0;

  const priceInfo = priceDetail.find((priceInfo) => priceInfo.title === '정가');

  if (priceInfo) {
    price = priceInfo.amount;
  }

  return price;
};
